import React from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import itc from "../../../assets/images/services/microsoft.jpg";
import ServiceSidebar2 from '../ServiceSidebar2/Main';
import { useTranslation } from 'react-i18next';


const Microsoft = () => {
	// const [clicked, setClicked] = useState(0);
	// const faqs = [
	// 	{
	// 		question: "Nulla eu nisi pellentesque, ultrices lorem eget, mattis dolo",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Praesent nec ante sed libero tempus rutrum",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Integer et mi in eros commodo bibendum",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Proin commodo turpis eu leo tempus varius",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	}
	// ]
  const { t } = useTranslation();
	return (
    <>
      <Breadcumb
        Title={t('microsoft_enterprise.breadcrumb_title')}
        Breadcumb={t('microsoft_enterprise.breadcrumb_parent')}
      />

      <section className="section-padding--bottom section-padding--top service-details--page">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="service-details__image">
                <img src={itc} alt="" />
              </div>

              <h3 className="service-details__title">
                {t('microsoft_enterprise.page_title')}
              </h3>

              <div className="service-details__content">
                <p>{t('microsoft_enterprise.intro_p1')}</p>
                <p>{t('microsoft_enterprise.intro_p2')}</p>

                <h4>{t('microsoft_enterprise.business_consulting_title')}</h4>
                <p>{t('microsoft_enterprise.business_consulting_desc1')}</p>
                <p>{t('microsoft_enterprise.business_consulting_desc2')}</p>
                <p>{t('microsoft_enterprise.business_consulting_desc3')}</p>

                <h4>{t('microsoft_enterprise.business_architecture_title')}</h4>
                <p>{t('microsoft_enterprise.business_architecture_desc1')}</p>
                <p>{t('microsoft_enterprise.business_architecture_desc2')}</p>
                <p>{t('microsoft_enterprise.business_architecture_desc3')}</p>

                <h4>{t('microsoft_enterprise.business_development_title')}</h4>
                <p>{t('microsoft_enterprise.business_development_desc1')}</p>
                <p>{t('microsoft_enterprise.business_development_desc2')}</p>

                <h4>{t('microsoft_enterprise.aspnet_dev_title')}</h4>
                <p>{t('microsoft_enterprise.aspnet_dev_desc1')}</p>
                <p>{t('microsoft_enterprise.aspnet_dev_desc2')}</p>

                <h5>{t('microsoft_enterprise.aspnet_services')}</h5>
                <ul>
                  <li>{t('microsoft_enterprise.aspnet_service1')}</li>
                  <li>{t('microsoft_enterprise.aspnet_service2')}</li>
                  <li>{t('microsoft_enterprise.aspnet_service3')}</li>
                  <li>{t('microsoft_enterprise.aspnet_service4')}</li>
                  <li>{t('microsoft_enterprise.aspnet_service5')}</li>
                  <li>{t('microsoft_enterprise.aspnet_service6')}</li>
                  <li>{t('microsoft_enterprise.aspnet_service7')}</li>
                  <li>{t('microsoft_enterprise.aspnet_service8')}</li>
                </ul>

                <h4>{t('microsoft_enterprise.net_mvc_title')}</h4>
                <p>{t('microsoft_enterprise.net_mvc_desc1')}</p>
                <p>{t('microsoft_enterprise.net_mvc_desc2')}</p>
                <p>{t('microsoft_enterprise.net_mvc_desc3')}</p>
                <ul>
                  <li>{t('microsoft_enterprise.net_mvc_service1')}</li>
                  <li>{t('microsoft_enterprise.net_mvc_service2')}</li>
                  <li>{t('microsoft_enterprise.net_mvc_service3')}</li>
                  <li>{t('microsoft_enterprise.net_mvc_service4')}</li>
                </ul>

                <h4>{t('microsoft_enterprise.csharp_dev_title')}</h4>
                <p>{t('microsoft_enterprise.csharp_dev_desc')}</p>
                <ul>
                  <li>{t('microsoft_enterprise.csharp_service1')}</li>
                  <li>{t('microsoft_enterprise.csharp_service2')}</li>
                  <li>{t('microsoft_enterprise.csharp_service3')}</li>
                  <li>{t('microsoft_enterprise.csharp_service4')}</li>
                  <li>{t('microsoft_enterprise.csharp_service5')}</li>
                  <li>{t('microsoft_enterprise.csharp_service6')}</li>
                  <li>{t('microsoft_enterprise.csharp_service7')}</li>
                  <li>{t('microsoft_enterprise.csharp_service8')}</li>
                  <li>{t('microsoft_enterprise.csharp_service9')}</li>
                </ul>

                <h4>{t('microsoft_enterprise.mvvm_title')}</h4>
                <p>{t('microsoft_enterprise.mvvm_desc')}</p>
                <ul>
                  <li>{t('microsoft_enterprise.mvvm_feature1')}</li>
                  <li>{t('microsoft_enterprise.mvvm_feature2')}</li>
                  <li>{t('microsoft_enterprise.mvvm_feature3')}</li>
                  <li>{t('microsoft_enterprise.mvvm_feature4')}</li>
                </ul>

                <h4>{t('microsoft_enterprise.sharepoint_title')}</h4>
                <p>{t('microsoft_enterprise.sharepoint_intro')}</p>
                <ul>
                  <li>{t('microsoft_enterprise.sharepoint_consulting')}</li>
                  <li>{t('microsoft_enterprise.sharepoint_customization')}</li>
                  <li>{t('microsoft_enterprise.sharepoint_upgrade')}</li>
                  <li>{t('microsoft_enterprise.sharepoint_reporting')}</li>
                  <li>{t('microsoft_enterprise.sharepoint_implementation')}</li>
                  <li>{t('microsoft_enterprise.sharepoint_managed')}</li>
                </ul>

                <h4>{t('microsoft_enterprise.wcf_title')}</h4>
                <p>{t('microsoft_enterprise.wcf_desc')}</p>
                <ul>
                  <li>{t('microsoft_enterprise.wcf_why_use')}</li>
                  <li>{t('microsoft_enterprise.wcf_industry')}</li>
                  <li>{t('microsoft_enterprise.wcf_customization')}</li>
                  <li>{t('microsoft_enterprise.wcf_practices')}</li>
                  <li>{t('microsoft_enterprise.wcf_maintainable')}</li>
                </ul>

                <h4>{t('microsoft_enterprise.azure_title')}</h4>
                <p>{t('microsoft_enterprise.azure_intro')}</p>
                <ul>
                  <li>{t('microsoft_enterprise.azure_cost')}</li>
                  <li>{t('microsoft_enterprise.azure_performance')}</li>
                  <li>{t('microsoft_enterprise.azure_no_fees')}</li>
                  <li>{t('microsoft_enterprise.azure_recovery')}</li>
                  <li>{t('microsoft_enterprise.azure_iso')}</li>
                  <li>{t('microsoft_enterprise.azure_uptime')}</li>
                  <li>{t('microsoft_enterprise.azure_scalable')}</li>
                  <li>{t('microsoft_enterprise.azure_integrate')}</li>
                  <li>{t('microsoft_enterprise.azure_migration')}</li>
                </ul>

                <h4>{t('microsoft_enterprise.silverlight_title')}</h4>
                <p>{t('microsoft_enterprise.silverlight_intro')}</p>
                <p>{t('microsoft_enterprise.silverlight_desc')}</p>
                <ul>
                  <li>{t('microsoft_enterprise.silverlight_advantage1')}</li>
                  <li>{t('microsoft_enterprise.silverlight_advantage2')}</li>
                  <li>{t('microsoft_enterprise.silverlight_advantage3')}</li>
                  <li>{t('microsoft_enterprise.silverlight_advantage4')}</li>
                </ul>
              </div>

              <div className="row gutter-y-30 service-details__box-wrapper">
                <div className="col-md-6 col-sm-12">
                  <div className="service-details__box">
                    <i className="service-details__box__icon icon-consulting"></i>
                    <div className="service-details__box__content">
                      <h3 className="service-details__box__title">
                        <Link to="#">{t('microsoft_enterprise.box_title1')}</Link>
                      </h3>
                      <p className="service-details__box__text">
                        {t('microsoft_enterprise.box_text1')}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12">
                  <div className="service-details__box">
                    <i className="service-details__box__icon icon-chip"></i>
                    <div className="service-details__box__content">
                      <h3 className="service-details__box__title">
                        <Link to="#">{t('microsoft_enterprise.box_title2')}</Link>
                      </h3>
                      <p className="service-details__box__text">
                        {t('microsoft_enterprise.box_text2')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

      
              {/* <div className="row gutter-y-30">
                <div className="col-md-6 col-sm-12">
                  <img
                    src="assets/images/services/service-d-2.jpg"
                    className="service-details__sub-image"
                    alt=""
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="service-details__caption">
                    <h3 className="service-details__caption__title">
                      Our Benefits
                    </h3>
                    <p className="service-details__caption__text">
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum.
                    </p>
                    <ul className="service-details__caption__list">
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Praesent efficitur quam sit amet
                      </li>
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Nunc cursus dolor id purus euismod
                      </li>
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Quisque tincidunt eros ac place viverra
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}

              {/* <div className="row">
                <div className="col-md-12">
                  <div
                    className="accrodion-grp service-details__accrodion"
                    data-grp-name="service-details__accrodion-1"
                  >
                    {faqs.map((item, index) => (
                      <div
                        className={`accrodion wow fadeInUp ${
                          index === clicked && "active"
                        }`}
                        key={index}
                        data-wow-delay="0ms"
                      >
                        <div className="accrodion-title">
                          <h4 onClick={() => setClicked(index)}>
                            {item.question}
                            <span className="accrodion-icon"></span>
                          </h4>
                        </div>
                        {index === clicked && (
                          <div className="accrodion-content">
                            <div className="inner">
                              <p>{item.answer}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div> */}
            </div>
            <div className="col-lg-4 sidebar-column">
              <ServiceSidebar2/>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Microsoft